import { render, staticRenderFns } from "./myClient.vue?vue&type=template&id=6e56abe1&scoped=true&"
import script from "./myClient.vue?vue&type=script&lang=ts&"
export * from "./myClient.vue?vue&type=script&lang=ts&"
import style0 from "./myClient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./myClient.vue?vue&type=style&index=1&id=6e56abe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56abe1",
  null
  
)

export default component.exports